var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { runtime } from '../../../../classes/runtime/Runtime';
export class MenubarUserDialogs {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get menubarUser() {
        return this.parent;
    }
    get app() {
        return this.menubarUser.app;
    }
    isCustomDialogOpen = false; // manually set for e.g. sweetalert inputs
    isRegisterModalOpen = false;
    isSettingsModalOpen = false;
    get isAutomaticCompleteUserDataModalOpen() {
        if (!this.app.user.userQuery.isAvailable)
            return false;
        if (this.isRegisterModalOpen)
            return false;
        if (this.isCompleteUserDataModalExplicitlyClosed)
            return false;
        if (this.app.user.userData.totalAnswered < 30)
            return false;
        if (!this.app.user.userInfo.isGuestUser)
            return false;
        if (this.app.cycle.frontalNumber !== 9)
            return false;
        return true;
    }
    isCompleteUserDataModalExplicitlyClosed = false;
    isVerifyEmailModalExplicitlyClosed = false;
    get isAutomaticFixEmailDialogOpen() {
        return false;
        if (!this.app.user)
            return false;
        if (this.isFixEmailModalExplicitlyClosed)
            return false;
        if (this.app.user.userData.emailFails < 3)
            return false;
        if (this.app.cycle.frontalNumber !== 5)
            return false;
        if (this.app.user.userData.totalAnswered < 60)
            return false;
        return true;
    }
    isFixEmailModalExplicitlyClosed = false;
    get settingsModal() {
        return new runtime.solidPackages.Lazy.components.MenubarUserDialogSettings(this.menubarUser);
    }
    get registerModal() {
        return new runtime.solidPackages.Lazy.components.MenubarUserDialogRegister(this.menubarUser);
    }
    get fixEmail() {
        return new runtime.solidPackages.Lazy.components.MenubarUserDialogFixEmail(this.menubarUser);
    }
    get isAnyUserDialogShown() {
        if (this.menubarUser.isUserMenuOpen)
            return true;
        if (this.isRegisterModalOpen)
            return true;
        if (this.isSettingsModalOpen)
            return true;
        if (this.isAutomaticCompleteUserDataModalOpen)
            return true;
        if (this.isAutomaticFixEmailDialogOpen)
            return true;
        return false;
    }
    closeAllModals() {
        this.isRegisterModalOpen = false;
        this.isSettingsModalOpen = false;
    }
    showLogoutModal() {
        this.closeAllModals();
        this.menubarUser.isUserMenuOpen = false;
    }
    showRegisterModal() {
        this.menubarUser.isUserMenuOpen = false;
        this.closeAllModals();
        this.isRegisterModalOpen = true;
    }
    closeUserDrawer() {
        this.menubarUser.isUserMenuOpen = false;
    }
}
__decorate([
    observable
], MenubarUserDialogs.prototype, "isCustomDialogOpen", void 0);
__decorate([
    observable
], MenubarUserDialogs.prototype, "isRegisterModalOpen", void 0);
__decorate([
    observable
], MenubarUserDialogs.prototype, "isSettingsModalOpen", void 0);
__decorate([
    computed
], MenubarUserDialogs.prototype, "isAutomaticCompleteUserDataModalOpen", null);
__decorate([
    observable
], MenubarUserDialogs.prototype, "isCompleteUserDataModalExplicitlyClosed", void 0);
__decorate([
    observable
], MenubarUserDialogs.prototype, "isVerifyEmailModalExplicitlyClosed", void 0);
__decorate([
    computed
], MenubarUserDialogs.prototype, "isAutomaticFixEmailDialogOpen", null);
__decorate([
    observable
], MenubarUserDialogs.prototype, "isFixEmailModalExplicitlyClosed", void 0);
__decorate([
    memoize
], MenubarUserDialogs.prototype, "settingsModal", null);
__decorate([
    memoize
], MenubarUserDialogs.prototype, "registerModal", null);
__decorate([
    memoize
], MenubarUserDialogs.prototype, "fixEmail", null);
__decorate([
    computed
], MenubarUserDialogs.prototype, "isAnyUserDialogShown", null);
__decorate([
    action.bound
], MenubarUserDialogs.prototype, "closeAllModals", null);
__decorate([
    action.bound
], MenubarUserDialogs.prototype, "showLogoutModal", null);
__decorate([
    action.bound
], MenubarUserDialogs.prototype, "showRegisterModal", null);
__decorate([
    action.bound
], MenubarUserDialogs.prototype, "closeUserDrawer", null);
